import * as React from "react";

function SvgIcons8Replace(props, ref) {
  return (
    <svg viewBox="0 0 32 32" width="1em" height="1em" {...{ ...props, ref }}>
      <path d="M16 4C9.383 4 4 9.383 4 16c0 3.07 1.156 5.875 3.063 8H5v2h6v-6H9v3.125A9.966 9.966 0 016 16c0-5.535 4.465-10 10-10zm2.25.219l-.563 1.937c.66.114 1.317.29 1.938.532l.531-1.938c-.625-.23-1.25-.406-1.906-.531zM21 6v6h2V8.875A9.93 9.93 0 0126 16c0 5.535-4.465 10-10 10v2c6.617 0 12-5.383 12-12 0-3.078-1.18-5.879-3.094-8H27V6zm-8.625 19.313l-.531 1.937c.625.23 1.25.406 1.906.531l.563-1.937c-.66-.114-1.317-.29-1.938-.532z" />
    </svg>
  );
}

export default React.forwardRef(SvgIcons8Replace);
